import classNames from "classnames";
import { FC, ReactNode } from "react";

export const FormLabel: FC<{ htmlFor: string; className?: string; children: ReactNode; id: string }> = ({
  htmlFor,
  className = "text-black font-semibold text-[14px]",
  children,
  id
}) => {
  return (
    <section className="relative">
      <label className={classNames("block text-left leading-snug mb-2", className)} id={id} htmlFor={htmlFor}>
        {children}
      </label>
    </section>
  );
};
